module.exports = __webpack_public_path__ + "img/border_line.74eed567.svg";